<template>
  <div class="wedding">
    <!-- 炫酷背景动画层 -->
    <div class="background-animation">
      <!-- 飘落的花瓣/囍字 -->
      <div v-for="n in 20" :key="n" class="floating-particle" 
           :style="{
             left: Math.random() * 100 + '%',
             animationDelay: Math.random() * 10 + 's',
             animationDuration: (Math.random() * 10 + 10) + 's',
             fontSize: (Math.random() * 30 + 20) + 'px'
           }">
        {{ ['❤️', '囍', '🌸', '🎉', '✨'][Math.floor(Math.random() * 5)] }}
      </div>
      
      <!-- 闪烁的霓虹光晕 -->
      <div class="neon-overlay"></div>
      
      <!-- 金色粒子 -->
      <div v-for="n in 30" :key="'particle'+n" class="golden-particle"
           :style="{
             left: Math.random() * 100 + '%',
             top: Math.random() * 100 + '%',
             animationDelay: Math.random() * 5 + 's',
             width: (Math.random() * 6 + 2) + 'px',
             height: (Math.random() * 6 + 2) + 'px'
           }">
      </div>
    </div>
    
    <!-- 原有的编辑器 -->
    <Editor/>
  </div>
</template>

<script>
  import Editor from "./components/Editor.vue"

  export default {
    props: [],
    components: {
      Editor
    },
    name: 'Wedding'
  }
</script>

<style lang="less">
@import './assets/base.less';

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.wedding {
  position: relative;
  max-width: 568px !important;
  height: 100%;
  min-height: 100%;
  margin: 0 auto;
  background: linear-gradient(135deg, #4A1A2A 0%, #6B2E3E 50%, #8B4A5A 100%);
  perspective: 500px;
  overflow: hidden;
  
  // 背景动画层
  .background-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    
    // 飘落的花瓣/囍字
    .floating-particle {
      position: absolute;
      top: -10vh;
      color: rgba(255, 215, 0, 0.6);
      font-size: 24px;
      animation: fallFlowers linear infinite;
      text-shadow: 0 0 15px rgba(255, 69, 0, 0.5);
      z-index: 1;
      pointer-events: none;
    }
    
    // 霓虹光晕
    .neon-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(circle at 30% 50%, 
                                  rgba(255, 69, 0, 0.2) 0%,
                                  rgba(255, 215, 0, 0.1) 50%,
                                  transparent 80%);
      animation: neonGlow 8s ease infinite;
      z-index: 2;
      pointer-events: none;
    }
    
    // 金色粒子
    .golden-particle {
      position: absolute;
      background: rgba(255, 215, 0, 0.6);
      border-radius: 50%;
      box-shadow: 0 0 20px rgba(255, 215, 0, 0.8);
      animation: particleTwinkle 3s ease-in-out infinite;
      z-index: 1;
      pointer-events: none;
    }
  }
  
  // 确保编辑器内容在动画上层
  .wedding-editor {
    position: relative;
    z-index: 10;
    background: transparent; // 透明背景，显示下面的动画
  }
}
</style>